// extracted by mini-css-extract-plugin
export default {"primaryFooter":"Footer_primaryFooter__WNcvp"};